/**
 * Pongbot26 — BOGO 赠品自动进购物车（配合后台原生 Buy X get Y）
 *
 * 规则（与运营确认一致）：
 * - 整单最多 1 份赠品，多档同时命中时按优先级互斥：赠品1 > 赠品2 > 赠品3。
 * - qualifying 任意命中「商品1 活动款列表」→ 只送 1 份赠品1。
 * - 未命中赠品1 且 qualifying 任意命中「商品2 活动款列表」→ 只送 1 份赠品2。
 * - 未命中赠品1、赠品2 且 qualifying 任意命中「商品3 活动款列表」→ 只送 1 份赠品3。
 * - 不写入 line item properties。
 *
 * Buy it now / PayPal等会先加购再立刻跳转 /checkout；脚本会拦截同域结账导航，在跳转前跑完赠品同步。
 *
 * 配置：在下方 BASE 中填写 variant id（数字字符串即可），或在 theme.liquid 里先于本文件定义
 * window.PONGBOT26_BOGO_CONFIG = { ... } 覆盖。
 */
(function () {
  'use strict';

  var BASE = {
    qualifyingGift1VariantIds: [
      '47876073292029',
      '47876073357565',
      '47876073160957',
      '47876073226493',
      '71261256286461',
      '71261256319229',
      '71261256351997',
    ],
    qualifyingGift2VariantIds: [
      '46620062515453',
      '47282921046269',
      '47282921079037',
      '47184652468477',
      '47184664035581',
    ],
    qualifyingGift3VariantIds: [
      '47239924809981',
      '47239924252925',
    ],
    gift1VariantId: '71614402920701',
    gift2VariantId: '71614399316221',
    gift3VariantId: '71614403674365',
  };

  var CFG = Object.assign({}, BASE, typeof window.PONGBOT26_BOGO_CONFIG === 'object' && window.PONGBOT26_BOGO_CONFIG ? window.PONGBOT26_BOGO_CONFIG : {});

  function normId(id) {
    return id == null || id === '' ? '' : String(id);
  }

  function isConfigured() {
    var g1 = normId(CFG.gift1VariantId);
    var g2 = normId(CFG.gift2VariantId);
    var g3 = normId(CFG.gift3VariantId);
    var q1 = CFG.qualifyingGift1VariantIds || [];
    var q2 = CFG.qualifyingGift2VariantIds || [];
    var q3 = CFG.qualifyingGift3VariantIds || [];
    var ok1 = g1 && q1.length > 0;
    var ok2 = g2 && q2.length > 0;
    var ok3 = g3 && q3.length > 0;
    return ok1 || ok2 || ok3;
  }

  if (!isConfigured()) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[pongbot26-bogo] 未配置赠品/qualifying variant id，已跳过加载逻辑。');
    }
    return;
  }

  if (document.documentElement.classList.contains('shopify-design-mode')) {
    return;
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /** >0 时表示正在同步，供 xo-cart 订阅回调忽略、避免与 merge递归 */
  var syncDepth = 0;
  var syncInFlight = false;
  var syncPending = false;
  var debounceTimer = null;
  var DEBOUNCE_MS = 300;
  /** 并发只跑一份 reconcile（抽屉同步与结账拦截可共用） */
  var reconcilePromise = null;
  /** 为 true 时放行 Location补丁，避免递归 */
  var bypassCheckoutNavGuard = false;
  /** >0 表示当前 fetch 来自本脚本，避免 cart钩子递归触发 */
  var fromInternalCartApi = 0;
  /** 遇到 429/5xx 时的退避截止时间（ms 时间戳）；scheduleSync 会延后到此之后再跑 */
  var rateLimitedUntil = 0;
  var RATE_LIMIT_BACKOFF_MS = 5000;
  /** 上一次成功开跑 reconcile 的时间戳，做硬性最小间隔，防止风暴 */
  var lastReconcileAt = 0;
  var MIN_RECONCILE_INTERVAL_MS = 800;
  /** 上一次 onXoCartState 看到的 cart 内容摘要；摘要不变就跳过，避免 loading 翻转触发 reconcile */
  var lastCartSignature = null;
  /** 上一轮 reconcile 时购物车是否含 qualifying 商品（用于检测活动结束） */
  var lastHadQualifying1 = false;
  var lastHadQualifying2 = false;
  /** gift2：本轮 qualifying 会话中脚本自动加购的赠品数量（区分用户自购 vs 活动赠品） */
  var autoAddedGift2Qty = 0;

  // === 用户拒绝赠品的记忆（手动删除赠品后不再自动加回） ===
  var SUPPRESS_KEY = 'pongbot26.bogo.suppressed';
  var memorySuppressed = null;
  /** 上一轮 reconcile 完成后赠品在购物车中的目标数量，用于检测用户主动删除/加回 */
  var lastReconciledGiftQtys = null;

  function readSuppressedSet() {
    var arr = null;
    try {
      if (typeof sessionStorage !== 'undefined') {
        var raw = sessionStorage.getItem(SUPPRESS_KEY);
        if (raw) {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) arr = parsed;
        }
      }
    } catch (e) {}
    if (!arr) arr = memorySuppressed || [];
    var set = {};
    for (var i = 0; i < arr.length; i++) {
      var k = String(arr[i]);
      if (k) set[k] = true;
    }
    return set;
  }

  function writeSuppressedSet(set) {
    var arr = Object.keys(set);
    memorySuppressed = arr;
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(SUPPRESS_KEY, JSON.stringify(arr));
      }
    } catch (e) {}
  }

  function addSuppressed(vid) {
    var v = normId(vid);
    if (!v) return;
    var set = readSuppressedSet();
    if (set[v]) return;
    set[v] = true;
    writeSuppressedSet(set);
  }

  function removeSuppressed(vid) {
    var v = normId(vid);
    if (!v) return;
    var set = readSuppressedSet();
    if (!set[v]) return;
    delete set[v];
    writeSuppressedSet(set);
  }

  function clearSuppressed() {
    memorySuppressed = [];
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem(SUPPRESS_KEY);
      }
    } catch (e) {}
  }

  function isSameOriginCheckoutUrl(url) {
    if (url == null || url === '') return false;
    try {
      var u = new URL(String(url), window.location.origin);
      if (u.origin !== window.location.origin) return false;
      var p = u.pathname || '';
      return /^(\/[a-z]{2}(-[a-z]+)?)?\/checkout(\/|$|\?)/i.test(p) || /^(\/[a-z]{2}(-[a-z]+)?)?\/checkouts\//i.test(p);
    } catch (e) {
      return false;
    }
  }

  function isBfDiscountRequest(init, input) {
    var headers = null;
    if (init && init.headers) headers = init.headers;
    else if (typeof Request !== 'undefined' && input instanceof Request) headers = input.headers;
    if (!headers) return false;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      return headers.get('X-Pongbot-Bf-Discount') === '1';
    }
    return headers['X-Pongbot-Bf-Discount'] === '1' || headers['x-pongbot-bf-discount'] === '1';
  }

  function afterGiftsThen(navigate) {
    runGiftReconcile()
      .catch(function () {})
      .then(function () {
        var api = window.PongbotBfDiscount;
        if (api && typeof api.flush === 'function') return api.flush();
      })
      .catch(function () {})
      .finally(navigate);
  }

  function installCheckoutNavigationGuard() {
    if (window.__pongbot26BogoCheckoutGuardInstalled) return;
    var proto = window.Location && window.Location.prototype;
    if (!proto) return;

    try {
      var hrefDesc = Object.getOwnPropertyDescriptor(proto, 'href');
      if (hrefDesc && hrefDesc.configurable !== false && typeof hrefDesc.set === 'function') {
        var origHrefSet = hrefDesc.set;
        Object.defineProperty(proto, 'href', {
          configurable: true,
          enumerable: hrefDesc.enumerable,
          get: hrefDesc.get,
          set: function (v) {
            var self = this;
            if (bypassCheckoutNavGuard || !isSameOriginCheckoutUrl(v)) {
              return origHrefSet.call(self, v);
            }
            afterGiftsThen(function () {
              bypassCheckoutNavGuard = true;
              try {
                origHrefSet.call(self, v);
              } finally {
                bypassCheckoutNavGuard = false;
              }
            });
          },
        });
      }
    } catch (e) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[pongbot26-bogo] 无法补丁 Location.href，Buy now 可能仍缺赠品。', e);
      }
    }

    try {
      if (typeof proto.assign === 'function' && !proto.assign.__pongbot26Wrapped) {
        var oa = proto.assign;
        var wa = function (url) {
          var self = this;
          if (bypassCheckoutNavGuard || !isSameOriginCheckoutUrl(url)) {
            return oa.call(self, url);
          }
          afterGiftsThen(function () {
            bypassCheckoutNavGuard = true;
            try {
              oa.call(self, url);
            } finally {
              bypassCheckoutNavGuard = false;
            }
          });
        };
        wa.__pongbot26Wrapped = true;
        proto.assign = wa;
      }
    } catch (e2) {}

    try {
      if (typeof proto.replace === 'function' && !proto.replace.__pongbot26Wrapped) {
        var or = proto.replace;
        var wr = function (url) {
          var self = this;
          if (bypassCheckoutNavGuard || !isSameOriginCheckoutUrl(url)) {
            return or.call(self, url);
          }
          afterGiftsThen(function () {
            bypassCheckoutNavGuard = true;
            try {
              or.call(self, url);
            } finally {
              bypassCheckoutNavGuard = false;
            }
          });
        };
        wr.__pongbot26Wrapped = true;
        proto.replace = wr;
      }
    } catch (e3) {}

    window.__pongbot26BogoCheckoutGuardInstalled = true;
  }

  /** sticky-cart、部分 App 用裸 fetch 加购，不会更新 xo-cart；拦截 cart 写入请求并在成功后同步赠品 */
  function installCartMutationFetchHook() {
    if (window.__pongbot26BogoFetchHookInstalled) return;
    var ofetch = window.fetch;
    if (typeof ofetch !== 'function') return;

    window.fetch = function (input, init) {
      var urlStr = '';
      if (typeof input === 'string') {
        urlStr = input;
      } else if (input && typeof input.url === 'string') {
        urlStr = input.url;
      }
      var method = 'GET';
      if (init && init.method) {
        method = String(init.method);
      } else if (typeof Request !== 'undefined' && input instanceof Request) {
        method = input.method || 'GET';
      }
           var path = '';
      try {
        if (/^https?:\/\//i.test(urlStr)) {
          path = new URL(urlStr).pathname || '';
        } else {
          path = String(urlStr || '').split('?')[0] || '';
        }
      } catch (e) {
        path = String(urlStr || '').split('?')[0] || '';
      }
      var isCartWrite =
        /\/cart\/(add|change|update)(\.js)?$/i.test(path) || /\/cart\/(add|change|update)$/i.test(path);
      var isMutating = /^(POST|PUT|PATCH|DELETE)$/i.test(method);

      var p = ofetch.apply(this, arguments);
      if (!isCartWrite || !isMutating) return p;

      return p.then(function (res) {
        try {
          if (res.ok && fromInternalCartApi === 0 && !bypassCheckoutNavGuard && !isBfDiscountRequest(init, input)) {
            // 用户主动 cart/add → 视为新决策时机，清除「拒绝赠品」记忆
            // （避免 sessionStorage 残留导致首次加 qualifying 也不自动加赠品）
            if (/\/cart\/add(\.js)?$/i.test(path)) {
              clearSuppressed();
            }
            scheduleSync();
          }
        } catch (e) {}
        return res;
      });
    };

    window.__pongbot26BogoFetchHookInstalled = true;
  }

  function stripSectionId(el) {
    if (!el || !el.id) return '';
    return String(el.id).replace(/^shopify-section-/, '');
  }

  /** 与 xo-webcomponents getServiceSections 对齐，保证抽屉/购物车区块能刷新 */
  function getCartSectionIds() {
    var path = window.location.pathname || '';
    var onCart = path.indexOf('/cart') !== -1;
    if (window.Xotiny) {
      var cartEl = document.querySelector('xo-cart');
      var miniEl = document.querySelector('xo-cart-mini');
      var cartId = cartEl && cartEl.id;
      var cartMiniId = miniEl && miniEl.id;
      if (onCart) {
        var xs = [cartId, cartMiniId].filter(Boolean);
        if (xs.length) return xs;
      } else if (cartMiniId) {
        return [cartMiniId];
      }
    }
    var cartItem = document.querySelector('.shopify-section[id^="shopify-section-template--"][id$="__cart-items"]');
    var cartFooter = document.querySelector('.shopify-section[id^="shopify-section-template--"][id$="__cart-footer"]');
    if (onCart) {
      return [stripSectionId(cartItem), stripSectionId(cartFooter), 'cart-icon-bubble', 'cart-live-region-text'].filter(Boolean);
    }
    return ['cart-drawer', 'cart-icon-bubble'].filter(Boolean);
  }

  function mergeXoCartFromResponse(data) {
    if (!data || !window.xoStore) return;
    window.xoStore.set('xo-cart', function (prev) {
      var next = Object.assign({}, prev);
      if (typeof data.item_count === 'number') {
        next.size = data.item_count;
      }
      if (data.sections && typeof data.sections === 'object') {
        next.sections = Object.assign({}, prev.sections || {}, data.sections);
      }
      next.changeLineLoading = -1;
      next.addIdLoading = '';
      return next;
    })('pongbot26-bogo-gift/sync');
  }

  function cartFetchJson(url, body) {
    fromInternalCartApi++;
    return fetch(root + url.replace(/^\//, ''), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        if (!res.ok) {
          var status = res.status;
          // 限流/服务异常：触发退避，错误对象带 status 给上层识别
          if (status === 429 || (status >= 500 && status < 600)) {
            rateLimitedUntil = Date.now() + RATE_LIMIT_BACKOFF_MS;
          }
          return res.json().then(function (err) {
            err = err || {};
            err.status = status;
            throw err;
          }, function () {
            var err2 = new Error('cart_write_failed_' + status);
            err2.status = status;
            throw err2;
          });
        }
        return res.json();
      })
      .finally(function () {
        fromInternalCartApi--;
      });
  }

  var cartGetSeq = 0;

  function cartGetJsonOnce() {
    cartGetSeq++;
    // 加随机参数防止 Shopify prefetch / CDN / SPA 路由命中导致返回 HTML
    var url = root + 'cart.js?_=' + Date.now() + '_' + cartGetSeq;
    return fetch(url, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin',
    }).then(function (r) {
      if (!r.ok) {
        var err = new Error('cart_get_failed_' + r.status);
        err.status = r.status;
        throw err;
      }
      // 用 text() 解析，避免 r.json() 在响应是 HTML 时直接抛 SyntaxError
      return r.text().then(function (text) {
        var trimmed = (text || '').trim();
        if (!trimmed || (trimmed.charAt(0) !== '{' && trimmed.charAt(0) !== '[')) {
          var err2 = new Error('cart_get_not_json');
          err2.status = r.status;
          throw err2;
        }
        try {
          return JSON.parse(trimmed);
        } catch (e) {
          var err3 = new Error('cart_get_parse_failed');
          err3.status = r.status;
          throw err3;
        }
      });
    });
  }

  /** cart.js 偶发被 prefetch/SPA 拦截返回 HTML，做一次软重试 */
  function cartGetJson() {
    return cartGetJsonOnce().catch(function (err) {
      var msg = err && err.message;
      if (msg === 'cart_get_not_json' || msg === 'cart_get_parse_failed') {
        return new Promise(function (resolve) {
          setTimeout(resolve, 400);
        }).then(cartGetJsonOnce);
      }
      throw err;
    });
  }

  function variantTotalQty(cart, vid) {
    var t = 0;
    var vidS = normId(vid);
    (cart.items || []).forEach(function (item) {
      if (normId(item.variant_id) === vidS) {
        t += Number(item.quantity) || 0;
      }
    });
    return t;
  }

  function linesForVariant(cart, vid) {
    var vidS = normId(vid);
    var out = [];
    (cart.items || []).forEach(function (item, idx) {
      if (normId(item.variant_id) === vidS) {
        out.push({
          line: idx + 1,
          key: item.key || null,
          quantity: Number(item.quantity) || 0,
        });
      }
    });
    return out;
  }

  function cartHasAnyVariant(cart, ids) {
    for (var i = 0; i < ids.length; i++) {
      if (variantTotalQty(cart, ids[i]) > 0) return true;
    }
    return false;
  }

  function desiredGiftQtys(cart) {
    var q1 = CFG.qualifyingGift1VariantIds || [];
    var q2 = CFG.qualifyingGift2VariantIds || [];
    var q3 = CFG.qualifyingGift3VariantIds || [];
    var g1id = normId(CFG.gift1VariantId);
    var g2id = normId(CFG.gift2VariantId);
    var g3id = normId(CFG.gift3VariantId);
    var hit1 = g1id && q1.length && cartHasAnyVariant(cart, q1);
    var hit2 = g2id && q2.length && cartHasAnyVariant(cart, q2);
    var hit3 = g3id && q3.length && cartHasAnyVariant(cart, q3);
    if (hit1) {
      return { g1: 1, g2: 0, g3: 0 };
    }
    if (hit2) {
      return { g1: 0, g2: 1, g3: 0 };
    }
    if (hit3) {
      return { g1: 0, g2: 0, g3: 1 };
    }
    return { g1: 0, g2: 0, g3: 0 };
  }

  /** 用户主动删除过的赠品 → 不再自动加回；同一 variant 被手动加回 → 在 detect 阶段会清除 */
  function applySuppression(want) {
    var set = readSuppressedSet();
    var g1id = normId(CFG.gift1VariantId);
    var g2id = normId(CFG.gift2VariantId);
    var g3id = normId(CFG.gift3VariantId);
    if (g1id && set[g1id]) want.g1 = 0;
    if (g2id && set[g2id]) want.g2 = 0;
    if (g3id && set[g3id]) want.g3 = 0;
    return want;
  }

  /**
   * 比较「上轮 reconcile 设定的赠品目标数量」和当前购物车，判断用户是否手动改动赠品行：
   * - 上次目标>0 但现在=0：用户主动删除 → 加入拒绝列表
   * - 上次目标=0 但现在>0：用户主动加回 → 解除拒绝列表
   * 用「目标值」作为基线，可正确忽略脚本自己造成的删除/添加（fromInternalCartApi 也会避免重复触发）
   */
  function detectGiftStateChange(cart) {
    if (!lastReconciledGiftQtys) return;
    var g1id = normId(CFG.gift1VariantId);
    var g2id = normId(CFG.gift2VariantId);
    var g3id = normId(CFG.gift3VariantId);
    if (g1id) {
      var prev1 = Number(lastReconciledGiftQtys[g1id] || 0);
      var cur1 = variantTotalQty(cart, g1id);
      if (prev1 > 0 && cur1 === 0) addSuppressed(g1id);
      else if (prev1 === 0 && cur1 > 0) removeSuppressed(g1id);
    }
    if (g2id) {
      var prev2 = Number(lastReconciledGiftQtys[g2id] || 0);
      var cur2 = variantTotalQty(cart, g2id);
      if (prev2 > 0 && cur2 === 0) addSuppressed(g2id);
      else if (prev2 === 0 && cur2 > 0) removeSuppressed(g2id);
    }
    if (g3id) {
      var prev3 = Number(lastReconciledGiftQtys[g3id] || 0);
      var cur3 = variantTotalQty(cart, g3id);
      if (prev3 > 0 && cur3 === 0) addSuppressed(g3id);
      else if (prev3 === 0 && cur3 > 0) removeSuppressed(g3id);
    }
  }

  /**
   * 把 variant 的购物车数量调整到 target；不调用 cartGetJson，避免再多打一次 cart.js。
   * - 增加：调 cart/add.js（其响应不含完整 cart）→ 本地估算更新 workingCart
   * - 减少/清零：调 cart/change.js（其响应是完整 cart）→ 直接用响应替换 workingCart
   * 返回 { lastData, cart }：lastData 用于刷新 xo-cart sections，cart 是最新本地状态供下一个 variant 使用
   */
  function applyVariantTarget(cart, variantId, target) {
    var vid = normId(variantId);
    var noop = { lastData: null, cart: cart };
    if (!vid) return Promise.resolve(noop);
    var current = variantTotalQty(cart, vid);
    if (current === target) return Promise.resolve(noop);

    var sections = getCartSectionIds();
    var section_url = window.location.pathname || '/';
    var lastData = null;
    var workingCart = cart;

    function setLineQty(lineRow, q) {
      var body = {
        quantity: q,
        sections: sections,
        section_url: section_url,
      };
      // 优先用 line key（稳定字符串，删除/移位都不变），退化用 line 序号
      if (lineRow.key) body.id = lineRow.key;
      else body.line = lineRow.line;
      return cartFetchJson('cart/change.js', body).then(function (data) {
        lastData = data;
        if (data && Array.isArray(data.items) && typeof data.item_count === 'number') {
          workingCart = data;
        }
        return data;
      });
    }

    if (current < target) {
      var toAdd = target - current;
      return cartFetchJson('cart/add.js', {
        items: [{ id: Number(vid), quantity: toAdd }],
        sections: sections,
        section_url: section_url,
      }).then(function (data) {
        lastData = data;
        // cart/add.js 返回的 items 仅包含本次 added 行，不含完整 cart，本地估算 workingCart
        var copy = Object.assign({}, workingCart);
        copy.items = (workingCart.items || []).slice();
        var found = false;
        for (var i = 0; i < copy.items.length; i++) {
          if (normId(copy.items[i].variant_id) === vid) {
            copy.items[i] = Object.assign({}, copy.items[i], {
              quantity: (Number(copy.items[i].quantity) || 0) + toAdd,
            });
            found = true;
            break;
          }
        }
        if (!found) {
          copy.items.push({ variant_id: vid, quantity: toAdd });
        }
        copy.item_count = (Number(workingCart.item_count) || 0) + toAdd;
        workingCart = copy;
        return { lastData: lastData, cart: workingCart };
      });
    }

    // current > target（含 target=0）：依次调小，直至总量到 target
    var toRemove = current - target;
    function step() {
      if (toRemove <= 0) return Promise.resolve();
      var lines = linesForVariant(workingCart, vid);
      if (!lines.length) return Promise.resolve();
      var row = lines[0];
      var dec = Math.min(row.quantity, toRemove);
      if (dec <= 0) return Promise.resolve();
      toRemove -= dec;
      return setLineQty(row, row.quantity - dec).then(step);
    }
    return step().then(function () {
      return { lastData: lastData, cart: workingCart };
    });
  }

  function recordBaseline(g1, t1, g2, t2, g3, t3) {
    lastReconciledGiftQtys = {};
    if (g1) lastReconciledGiftQtys[g1] = t1;
    if (g2) lastReconciledGiftQtys[g2] = t2;
    if (g3) lastReconciledGiftQtys[g3] = t3;
  }

  /**
   * gift1（Pace S Pro freebie）：无 qualifying 主品时不允许单独留车，一律清零。
   */
  function computeGift1Target(hasQualifying, wantQty) {
    return hasQualifying ? wantQty : 0;
  }

  /** gift3：与赠品1相同，不再是当前应送赠品时一律清零。 */
  function computeGift3Target(hasQualifying, wantQty) {
    return hasQualifying ? wantQty : 0;
  }

  /**
   * gift2：有 qualifying 时按活动规则；qualifying 刚结束时只回收脚本自动加购的部分；
   * 其余情况保留当前数量（允许捡球器等赠品 SKU 单独购买）。
   */
  function computeGift2Target(hasQualifying, lastHadQualifying, wantQty, currentQty, autoAddedQty) {
    if (hasQualifying) return wantQty;
    if (lastHadQualifying) return Math.max(0, currentQty - autoAddedQty);
    return currentQty;
  }

  function finishReconcileState(hasQ1, hasQ2, willAdd2, leftQ2) {
    if (willAdd2 > 0) autoAddedGift2Qty += willAdd2;
    if (leftQ2) autoAddedGift2Qty = 0;
    lastHadQualifying1 = hasQ1;
    lastHadQualifying2 = hasQ2;
  }

  function runGiftReconcile() {
    if (reconcilePromise) return reconcilePromise;
    // 退避期内 / 距离上次太近 → 直接放弃这次（debouncer 之后会重新触发）
    var now = Date.now();
    if (now < rateLimitedUntil) return Promise.resolve();
    if (now - lastReconcileAt < MIN_RECONCILE_INTERVAL_MS) return Promise.resolve();
    lastReconcileAt = now;
    syncDepth++;
    reconcilePromise = cartGetJson()
      .then(function (cart) {
        // 购物车清空（含订单完成后 Shopify 自动清空）→ 重置「拒绝赠品」记忆
        if ((cart.item_count || 0) === 0) {
          clearSuppressed();
          lastReconciledGiftQtys = null;
          lastHadQualifying1 = false;
          lastHadQualifying2 = false;
          autoAddedGift2Qty = 0;
        } else {
          detectGiftStateChange(cart);
        }

        var q1 = CFG.qualifyingGift1VariantIds || [];
        var q2 = CFG.qualifyingGift2VariantIds || [];
        var q3 = CFG.qualifyingGift3VariantIds || [];
        var hasQ1 = q1.length > 0 && cartHasAnyVariant(cart, q1);
        var hasQ2 = q2.length > 0 && cartHasAnyVariant(cart, q2);
        var hasQ3 = q3.length > 0 && cartHasAnyVariant(cart, q3);

        if (hasQ2 && !lastHadQualifying2) autoAddedGift2Qty = 0;

        var want = applySuppression(desiredGiftQtys(cart));
        var g1 = normId(CFG.gift1VariantId);
        var g2 = normId(CFG.gift2VariantId);
        var g3 = normId(CFG.gift3VariantId);
        var c1 = g1 ? variantTotalQty(cart, g1) : 0;
        var c2 = g2 ? variantTotalQty(cart, g2) : 0;
        var c3 = g3 ? variantTotalQty(cart, g3) : 0;
        var leftQ2 = !hasQ2 && lastHadQualifying2;
        var t1 = g1 ? computeGift1Target(hasQ1, want.g1) : 0;
        var t2 = g2 ? computeGift2Target(hasQ2, lastHadQualifying2, want.g2, c2, autoAddedGift2Qty) : 0;
        var t3 = g3 ? computeGift3Target(hasQ3, want.g3) : 0;
        var willAdd2 = hasQ2 && t2 > c2 ? t2 - c2 : 0;

        // 关键优化：赠品数量已与目标一致 → 直接结束，不再发任何 cart 写请求
        if (c1 === t1 && c2 === t2 && c3 === t3) {
          recordBaseline(g1, t1, g2, t2, g3, t3);
          finishReconcileState(hasQ1, hasQ2, willAdd2, leftQ2);
          return null;
        }

        var lastData = null;
        var workingCart = cart;
        var p = Promise.resolve(null);

        if (c1 !== t1) {
          p = p.then(function () {
            return applyVariantTarget(workingCart, g1, t1);
          }).then(function (r) {
            if (r.lastData) lastData = r.lastData;
            workingCart = r.cart;
          });
        }
        if (c2 !== t2) {
          p = p.then(function () {
            return applyVariantTarget(workingCart, g2, t2);
          }).then(function (r) {
            if (r.lastData) lastData = r.lastData;
            workingCart = r.cart;
          });
        }
        if (c3 !== t3) {
          p = p.then(function () {
            return applyVariantTarget(workingCart, g3, t3);
          }).then(function (r) {
            if (r.lastData) lastData = r.lastData;
            workingCart = r.cart;
          });
        }

        return p.then(function () {
          if (lastData) mergeXoCartFromResponse(lastData);
          recordBaseline(g1, t1, g2, t2, g3, t3);
          finishReconcileState(hasQ1, hasQ2, willAdd2, leftQ2);
        });
      })
      .catch(function (err) {
        var status = err && err.status;
        var msg = err && err.message;
        if (status === 429 || (status >= 500 && status < 600)) {
          rateLimitedUntil = Date.now() + RATE_LIMIT_BACKOFF_MS;
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('[pongbot26-bogo] cart API 限流/异常 (' + status + ')，已退避 ' + RATE_LIMIT_BACKOFF_MS + 'ms');
          }
        } else if (msg === 'cart_get_not_json' || msg === 'cart_get_parse_failed') {
          // Shopify prefetch/SPA 路由偶发导致 cart.js 返回 HTML；本次跳过，下次 cart 操作时会重试
          rateLimitedUntil = Date.now() + 1500;
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('[pongbot26-bogo] cart.js 返回非 JSON（prefetch/SPA 干扰），本次跳过；下次 cart 操作时会重试');
          }
        } else if (typeof console !== 'undefined' && console.error) {
          console.error('[pongbot26-bogo] 同步失败', err);
        }
      })
      .finally(function () {
        syncDepth--;
        reconcilePromise = null;
      });
    return reconcilePromise;
  }

  function runSync() {
    if (syncInFlight) {
      syncPending = true;
      return;
    }
    syncInFlight = true;
    runGiftReconcile()
      .finally(function () {
        syncInFlight = false;
        if (syncPending) {
          syncPending = false;
          runSync();
        }
      });
  }

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    var now = Date.now();
    var wait = DEBOUNCE_MS;
    if (now < rateLimitedUntil) {
      wait = Math.max(wait, rateLimitedUntil - now + 100);
    }
    var sinceLast = now - lastReconcileAt;
    if (sinceLast < MIN_RECONCILE_INTERVAL_MS) {
      wait = Math.max(wait, MIN_RECONCILE_INTERVAL_MS - sinceLast + 50);
    }
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      runSync();
    }, wait);
  }

  function onXoCartState(state) {
    if (!state || syncDepth > 0 || syncInFlight) return;
    if (state.changeLineLoading !== -1) return;
    if (state.addIdLoading) return;
    // xo-cart state 的 size 是 cart item_count；只在数量变化时触发，避免 sections 刷新等无关事件
    var sig = String(state.size != null ? state.size : '?');
    if (sig === lastCartSignature) return;
    lastCartSignature = sig;
    scheduleSync();
  }

  function init() {
    installCartMutationFetchHook();
    installCheckoutNavigationGuard();
    document.addEventListener(
      'cart:refresh',
      function () {
        scheduleSync();
      },
      false
    );
    if (!window.xoStore || typeof window.xoStore.subscribe !== 'function') {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[pongbot26-bogo] 未找到 window.xoStore，购物车抽屉可能不会自动刷新，但结账前仍会同步赠品。');
      }
    } else {
      window.xoStore.subscribe('xo-cart', onXoCartState);
    }
    // 调试入口：可在 Console 里手动查看/清除「拒绝赠品」记忆
    try {
      window.pongbot26Bogo = {
        getSuppressed: function () { return Object.keys(readSuppressedSet()); },
        clearSuppressed: function () { clearSuppressed(); return 'cleared'; },
        forceSync: function () { lastReconcileAt = 0; rateLimitedUntil = 0; runSync(); return 'syncing'; },
        config: CFG,
      };
    } catch (e) {}
    setTimeout(function () {
      if (!syncInFlight) runSync();
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
